module.exports = __webpack_public_path__ + "img/warehouse_inventory.82285b4a.png";